import styled, { createGlobalStyle, css } from 'styled-components'
import { Container, Row } from 'reactstrap'

export const Global = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    width: 100%;
    height: 100%;
    min-height: 100%;
    min-width: 200px;
    overflow-x: hidden;
    background: #ffffff;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.33;
    font-family: "Nunito Sans", sans-serif;
  }

  ul,
  li,
  a,
  p,
  body,
  strong,
  div {
    margin: 0px;
    padding: 0px;
    font-family: 'Nunito Sans', sans-serif;
  }

  main {
    overflow: hidden;
    max-width: 100%;
  }

`
export const sizes = {
  xs: '12px',
  sm: '0.875rem',
  base: '1rem',
  lg: '2.75rem',
  xl: '3.5rem',
  xxl: '4.75rem',
  xxxl: '5.5rem',
  xxxxl: '6rem'
}

const HeadingStyle = css`
  margin-top: 0;
  margin-bottom: ${props => props.marginBottom || '16px'};
  font-weight: 900;
  font-family: 'Source Serif Pro', sans-serif;
  text-align: ${props => props.textAlign || 'center'};
`

export const H1 = styled.h1`
  ${HeadingStyle};
  font-size: ${sizes.xl};
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1;
  letter-spacing: -1.5px;
  @media (min-width: 600px) {
    font-size: ${sizes.xxl};
  }
  @media (min-width: 1024px) {
    font-size: ${sizes.xxxl};
    letter-spacing: 1px;
  }
  @media (min-width: 1280px) {
    font-size: ${sizes.xxxxl};
  }
`

export const H2 = styled.h2`
  ${HeadingStyle};
  font-size: 2.75rem;
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1;
  letter-spacing: -0.5px;
  @media (min-width: 600px) {
    font-size: 3rem;
  }
  @media (min-width: 1024px) {
    font-size: ${sizes.xxxl};
  }
  @media (min-width: 1280px) {
    font-size: 3.75rem;
  }
`

export const H3 = styled.h3`
  ${HeadingStyle};
  font-size: 2rem;
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1.1;
  letter-spacing: -1px;
  @media (min-width: 600px) {
    font-size: 2.5rem;
  }
  @media (min-width: 1024px) {
    font-size: 2.7273rem;
  }
  @media (min-width: 1280px) {
    font-size: 2.9545rem;
  }
`

export const H4 = styled.h4`
  ${HeadingStyle};
  font-size: 1.625rem;
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1.1;
  letter-spacing: -1px;
  @media (min-width: 600px) {
    font-size: 1.8182rem;
  }
  @media (min-width: 1024px) {
    font-size: 2.0455rem;
  }
  @media (min-width: 1280px) {
    font-size: 2.2727rem;
  }
`

export const H5 = styled.h5`
  ${HeadingStyle};
  font-size: 1.25rem;
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1.16;
  letter-spacing: 0;
  @media (min-width: 600px) {
    font-size: 1.2931rem;
  }
  @media (min-width: 1024px) {
    font-size: 1.5086rem;
  }
  @media (min-width: 1280px) {
    font-size: 1.5086rem;
  }
`

export const H6 = styled.h6`
  ${HeadingStyle};
  font-size: 1.125rem;
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1.3;
  letter-spacing: 0;
  @media (min-width: 600px) {
    font-size: 1.1538rem;
  }
  @media (min-width: 1024px) {
    font-size: 1.1538rem;
  }
  @media (min-width: 1280px) {
    font-size: 1.3462rem;
  }
`

export const ContainerLg = styled(Container)`
  @media (min-width: 1310px) {
    max-width: 1310px !important;
  }
`

export const Section = styled.div`
  width: 100%;
  padding: 60px 0;
  background-color: ${p => p.bgColor || p.theme.colors.white};
  @media screen and (min-width: 1025px) {
    padding: ${props => props.size || '100px 0'};
  }
`

export const Heading = styled.h3`
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  color: ${p => p.color || p.theme.colors.gold};
  margin-bottom: 15px;
  font-family: 'Source Serif Pro', sans-serif;
  @media screen and (min-width: 1025px) {
    font-size: 56px;
    margin-bottom: 13px;
  }
`
export const Subheading = styled.div`
  font-size: 20px;
  margin-bottom: 16px;
  font-weight: 300;
  text-align: center;
  color: ${p => p.color || p.theme.colors.gold};
  color: #85714d;
  @media screen and (min-width: 1025px) {
    font-size: 30px;
  }
`

export const Title = styled.div`
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -1px;
  line-height: 1;
  color: ${p => p.color || p.theme.colors.gold};
  margin-bottom: 15px;
  font-family: 'Source Serif Pro', sans-serif;
  @media screen and (min-width: 1025px) {
    font-size: 36px;
    margin-bottom: 16px;
  }
`

export const Paragraph = styled.p`
  font-size: ${sizes.sm};
  font-family: Nunito Sans, sans-serif;
  font-weight: 400;
  line-height: 1.75;
  margin-bottom: ${props => props.marginBottom || '16px'};
  color: ${p => p.color || p.theme.colors.blueGray};
`

export const Placeholder = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${p => p.theme.colors.lightBlue};
`

export const Blockquote = styled.div`
  font-size: ${sizes.base};
  line-height: 1.75;
  margin-bottom: ${sizes.base};
  text-align: center;
  color: ${p => p.color || p.theme.colors.darkGray};
`
export const Cite = styled.div`
  font-size: ${sizes.base};
  font-weight: 700;
  margin-bottom: ${props => props.marginBottom || sizes.xl};
  letter-spacing: -0.7px;
  text-align: center;
  color: ${p => p.color || p.theme.colors.darkGray};
`

export const TextContainer = styled.div`
  text-align: center;
`

export const Panel = styled.div`
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
  background-color: ${p => p.theme.colors.white};
  text-align: ${props => props.textAlign || 'center'};
  padding: ${props => props.padding || '0px 0px'};
`
export const RowCentered = styled(Row)`
  justify-content: center;
`
